import $ from 'jquery';



$(function() {
  function staySubscribedModal() {
    $('.js-nothanks-unsubscribe-me').on('click', function(e) {
      e.preventDefault();

      // $('.js-modal-close')[0].click();

      var formname = "emailPref2";
      var email = $("#emailValueForUnsubscribe").val();
      var reasonSelectValue = $("#reason_select option:selected").text();
      var allUnsubscribeValue = $("#unsub-all")[0].checked;

      var data = $.param({
        formname : formname,
        email : email,
        unsubscribe : "true",
        feedback : reasonSelectValue,
        allUnsub : allUnsubscribeValue
      });
      $.post( "/r/ajax/unsubscribeSubmit.jsp", data, function( msg ) {
        if(typeof(msg.success) == 'undefined') {
          msg = JSON.parse(msg);
        }
        if(msg.success || msg.success == 'true') {
          window.location.href = 'Unsubscribed.jsp?unsubscribed=true';
        } else {
          $('.js-modal-close').mousedown();
          var errorMessage = "We're sorry, an error occurred while attempting to unsubscribe you. Please contact sales@revolve.com for further assistance.";
          if(msg.msg0 != null) {
            errorMessage = msg.msg0;
          }
          $("#unsubscribe_id").closest('.field').addClass("is-error");
          $("#unsubscribe_id").html(errorMessage);
        }
      });
    });
    $('.js-stay-subscribed').on('click', function(e) {
      e.preventDefault();
      $.modal({
        url: './confirmation-promo-modal.jsp',
        triggerOpen: true,
        padding: false,
        fullHeight: true,
      })
    });
  }
  $('.js-unsubscribe-form').on('submit', function(e) {
    e.preventDefault();
    let allUnsub;
    if ($('#unsub-all').is(':checked')) {
      allUnsub = 'allUnsub'
    }
    var feedback = $("#reason_select").val();
    if(feedback !=null && feedback=='Select'){
      $("#unsubscribe_id").closest('.field').addClass("is-error");
      $('#reason_select').focus();
      return false;
    }else{
      $("#unsubscribe_id").closest('.field').removeClass("is-error");
      $('#reason_select').focus();
    }

    $.modal({
      url: "./discount-offer-modal.jsp",
      triggerOpen: true,
      returnFocus: $(this),
      padding: false,
      fullHeight: true,
      onComplete: function() {
        staySubscribedModal();
      }
    });
  });

  if (window.location.href.indexOf("Unsubscribed.jsp") > -1) {
    const urlParams = new URLSearchParams(window.location.search);
    const unsubscribedTrue = urlParams.get('unsubscribed');
    if (unsubscribedTrue) {
      $.modal({
        url: "./unsubscribe-notification-modal.jsp",
        triggerOpen: true,
        type: 'small',
      });
    }
  }

  // Edit: close others, open this row
  $(document).on('click', '.js-edit-sm', function () {
    $('.card__entry-section.is-editing').removeClass('is-editing');
    $(this).closest('.card__entry-section').addClass('is-editing').find('.sm-input').focus();
  });
})



// WEBPACK FOOTER //
// ./src/scripts/entry-points/settings/index.js